module.exports = __webpack_public_path__ + "img/jonder-logo.977c8c02.svg";